import { Modal } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Image from "../../common/image/Image";
import Footer from "../../layout/footer/Footer";
import { Typo } from "../../layout/theme";

const GUTTER = 10;

export default function FooterContainer({ img }) {
	return (
		<Footer>
			<Footer.Divider></Footer.Divider>
			<Footer.Main gutter={GUTTER}>
				<Link
					to="/"
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<Footer.Image>
						<Image
							src={img}
							style={{ height: "15%", width: "15%", objectFit: "cover" }}
						/>
					</Footer.Image>
				</Link>
				<Footer.Copy>Copyright © - Todos los derechos reservados</Footer.Copy>
			</Footer.Main>
		</Footer>
	);
}
